import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofz22V4t } from './pages-map'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4T: Record<
  Exclude<PageIdWoofz22V4t, PageIdWoofz22V4t.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofz22V4t.SEX_22V4T]: {
    id: PageIdWoofz22V4t.SEX_22V4T,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4t.DOG_AGE_22V4T]: {
    id: PageIdWoofz22V4t.DOG_AGE_22V4T,
    progressBar: 'controlled',
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4t.DOG_BREED_22V4T]: {
    id: PageIdWoofz22V4t.DOG_BREED_22V4T,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4t.URGE_22V4T]: {
    id: PageIdWoofz22V4t.URGE_22V4T,
    theme: THEMES.URGE,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4t.COMMANDS_61_22V4T]: {
    id: PageIdWoofz22V4t.COMMANDS_61_22V4T,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4t.COMMANDS_62_22V4T]: {
    id: PageIdWoofz22V4t.COMMANDS_62_22V4T,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4t.COMMANDS_63_22V4T]: {
    id: PageIdWoofz22V4t.COMMANDS_63_22V4T,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4t.URGE_2_22V4T]: {
    id: PageIdWoofz22V4t.URGE_2_22V4T,
    theme: THEMES.URGE,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4t.POTTY_22V4T]: {
    id: PageIdWoofz22V4t.POTTY_22V4T,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4t.BEHAVIOR_22V4T]: {
    id: PageIdWoofz22V4t.BEHAVIOR_22V4T,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4t.TRAINING_22V4T]: {
    id: PageIdWoofz22V4t.TRAINING_22V4T,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4t.PREPARE_FLOW_22V4T]: {
    id: PageIdWoofz22V4t.PREPARE_FLOW_22V4T,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4t.DOG_STATISTICS_22V4T]: {
    id: PageIdWoofz22V4t.DOG_STATISTICS_22V4T,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofz22V4t.EMAIL_22V4T]: {
    id: PageIdWoofz22V4t.EMAIL_22V4T,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4t.NEWSLETTER_URGE_22V4T]: {
    id: PageIdWoofz22V4t.NEWSLETTER_URGE_22V4T,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4t.LAST_CHANCE_OFFER_22V4T]: {
    id: PageIdWoofz22V4t.LAST_CHANCE_OFFER_22V4T,
  },
  [PageIdWoofz22V4t.SUBSCRIPTIONS_22V4T]: {
    id: PageIdWoofz22V4t.SUBSCRIPTIONS_22V4T,
  },
  [PageIdWoofz22V4t.CANCEL_OFFER_22V4T]: {
    id: PageIdWoofz22V4t.CANCEL_OFFER_22V4T,
  },
  [PageIdWoofz22V4t.CHAT_UPSELL_22V4T]: {
    id: PageIdWoofz22V4t.CHAT_UPSELL_22V4T,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4t.UPSELL_22V4T]: {
    id: PageIdWoofz22V4t.UPSELL_22V4T,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4t.DOWNLOAD_22V4T]: {
    id: PageIdWoofz22V4t.DOWNLOAD_22V4T,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
